export const iconFontAwesomeMedicalHealthPersonDotsFromLine = (
	<i className="fa-solid fa-person-dots-from-line"></i>
);
